import React from 'react';
import { useParams } from 'react-router';
import Collapsible from 'react-collapsible';
import CollapsibleTrigger from '../UI/CollapsibleTrigger';
import Drinks from './Drinks';
import { useRestaurant } from '../../utils/contexts/restaurant-context';
import { useTracker } from '../../utils/contexts/tracker-context';
import { useFilters } from '../../utils/contexts/filters-context';

export default function Beverage(props) {
    const { beverage, index } = props;

    const { type } = useParams();
    const { restaurant } = useRestaurant();
    const { trackDataFn } = useTracker();
    const { filters } = useFilters();

    const [open, setOpen] = React.useState(false);

    async function handleClick() {
        await trackDataFn(restaurant.id, restaurant.token, "categoryopen", {
            "type": type,
            "name": this.trigger.props.trigger.name,
            "is_campari": this.trigger.props.trigger.is_campari,
            "original_name": beverage.original_name,
            "id": beverage.id
        }, restaurant.has_orders);
        // try {
        //     await window.fbq("track", "ViewContent");
        // } catch (e) {
        //     console.log({ pixelError: e })
        // }
    }

    React.useEffect(() => { setOpen(false); }, [filters]);

    return (
        <Collapsible
            className="beverage"
            onOpen={handleClick}
            tabIndex={index}
            lazyRender={true}
            trigger={<CollapsibleTrigger index={index} trigger={beverage} setOpen={setOpen}></CollapsibleTrigger>}
            triggerWhenOpen={<CollapsibleTrigger index={index} trigger={beverage} opened setOpen={setOpen}></CollapsibleTrigger>}
            open={open}>
            <div>
                {process.env.REACT_APP_NAMESPACE === "sanpellegrino" && beverage.custom_theme_sanbitter === true ?
                    <img className="w-full px-10 bg-white" src="/assets/sanbitter/sanbitter-products.png" alt="san bitter products" /> :
                    null}

                {beverage.hasOwnProperty("nested") ?
                    <div className="nested">
                        {beverage.nested.map((c, index) =>
                            <div className="m-4 p-0.5 border-2 rounded-lg" key={index}>
                                <Beverage beverage={c} />
                            </div>)}
                    </div> :
                    <Drinks category={beverage} drinks={beverage.drinks} index={index} />}
            </div>
        </Collapsible>
    );
}
